import React, { Component } from 'react'
import burger from '../images/burger.png'
import AlertMessage from '../widgets/AlertMessage'

class ContainerWidget extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			title: props.title,
			buttonLeft: props.buttonLeft,
			buttonRight: props.buttonRight,
			content: props.content,
			onClick: props.onClick,
			menuLabel: "PERSONAL INFORMATION",
			showAddActivity: (props.showAddActivity)? true: false,
			showAdd: (props.showAdd)? true: false,
			showCancel: (props.showCancel)? true: false,
			showClose: (props.showClose)? true: false,
			showBack: (props.showBack)? true: false,
			showUpdate: (props.showUpdate)? true: false,
			showBurger: (props.showBurger)? true: false,
			showButtons: (props.showBack || props.showCancel || props.showClose || props.showUpdate || props.showAddActivity || props.showAdd)? true: false,
			showDelete: (props.showDelete)? true: false,
			showDissolve: (props.showDissolve)? true: false,
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.onClick !== prevProps.onClick) {
			this.setState({onClick: this.props.onClick})
		}
		if(this.props.content !== prevProps.content) {
			this.setState({content: this.props.content})
		}
	}

	render() {
		let jc = (this.state.showButtons)? "space-between": "center"
		return(<div className="container-widget">
			<div className="container-header" style={{'justify-content': jc}}>
				{this.state.showBack === true && <button type="submit" className="green-two" value="back" onClick={(e) => {
					this.state.onClick(this.props.signal, e.target.value)
				}}>BACK</button>}
				{this.state.showDelete === true && <button type="submit" className="delete" value="delete" onClick={(e) => {
					this.state.onClick(this.props.signal, e.target.value)
				}}>DELETE</button>}
				{this.state.showBurger === true && <div id="menubutton" >
					<img src={burger} id="burger-logo" alt="BURGER" onClick={(e) => {
						this.state.onClick("burger")
					}} />
					<div>{this.state.menuLabel}</div>
				</div>}
				{(this.state.showBack === false && this.state.showBurger === false && this.state.showDelete === false && this.state.showDissolve === false) && <div id="menubutton" ></div>}
				<div className="container-title">{this.state.title}</div>
				<div>
				{this.state.showDissolve === true && <button type="submit" className="dissolve" value="dissolve" onClick={(e) => {
					this.state.onClick(this.props.signal, e.target.value)
				}}>DISSOLVE CLUSTER</button>}
				{this.state.showUpdate === true && <button type="submit" className="green-two update" value="update" onClick={(e) => {
					this.state.onClick(this.props.signal, e.target.value)
				}}>UPDATE</button>}
				{this.state.showClose === true && <button type="submit" className="green-two" value="close" onClick={(e) => {
					this.state.onClick(this.props.signal, e.target.value)
				}}>CLOSE</button>}
				{this.state.showCancel === true && <button type="submit" className="green-two" value="cancel" onClick={(e) => {
					this.setState({
						showConfirmMessage: true,
						aMessage: 'Are you sure you want to cancel?'
					})
					{/* this.state.onClick(this.props.signal, e.target.value) */}
				}}>CANCEL</button>}
				{this.state.showAddActivity === true && <button type="submit" className="green-two add-activity" value="add-activity" onClick={(e) => {
					this.state.onClick(this.props.signal, e.target.value)
				}}>ADD ACTIVITY</button>}
				{this.state.showAdd === true && <button type="submit" className="green-two add" value="add" onClick={(e) => {
					this.state.onClick(this.props.signal, e.target.value)
				}}>ADD</button>}
				</div>
			</div>
			<div id="container-body">{this.state.content}</div>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.state.onClick(this.props.signal, e.target.value)
				}
			}} />}
		</div>)
	}
}

export default ContainerWidget
